module.exports = __webpack_public_path__ + "img/img_contact.ca22281e.jpg";